import React from 'react';
import { C } from '../constants/theme';
import { inputStyle } from './FormField';

export function SearchInput({ value, onChange, placeholder = 'Search…' }) {
  return (
    <div style={{ position: 'relative' }}>
      <span style={{
        position: 'absolute', left: 10, top: '50%',
        transform: 'translateY(-50%)', color: C.textMuted, fontSize: 16,
        pointerEvents: 'none',
      }}>
        🔍
      </span>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{ ...inputStyle, paddingLeft: 34, width: 240 }}
      />
    </div>
  );
}
